// src/landing/LeadsPage.jsx
// ─── vehicleiq.fr/leads — page de conversion (§1-15, §86-87) ────────────────
// Objectif unique : collecter des leads professionnels. Ni pricing, ni blog,
// ni FAQ, ni features, ni providers, ni témoignages. Le formulaire EST l'action
// principale, donc aucun CTA hero concurrent (§4).
//
// Publicités (§12-15) : deux gratte-ciels 300 × 600 encadrent le formulaire à
// partir de 1280 px. Entre 768 et 1279 px ils disparaissent — le formulaire ne
// doit jamais être comprimé pour leur faire de la place (§87). En dessous, une
// bannière 320 × 100 sous le formulaire, et seulement si elle est configurée.
//
// §24 — Un slot inactif ne rend RIEN : la grille se recentre d'elle-même
// puisqu'elle est en `justify-content: center` et non en trois colonnes fixes.

import { useEffect } from "react";
import DemoLeadForm from "./DemoLeadForm";
import AdFrame from "./AdFrame";
import { AutoBackdrop } from "./AutoBackdrop";

export default function LeadsPage({ apiUrl, onPrivacy, nav }) {
  // §94-95 — Page destinée à la publicité payante et proche de la home :
  // noindex, follow. Le budget de crawl va aux pages de contenu.
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.title = "Découvrir VIQ.AI — VehicleIQ";
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) { robots = document.createElement("meta"); robots.setAttribute("name", "robots"); document.head.appendChild(robots); }
    const prev = robots.getAttribute("content");
    robots.setAttribute("content", "noindex, follow");
    return () => { if (prev) robots.setAttribute("content", prev); else robots.remove(); };
  }, []);

  return (
    <main className="lv2-leads">
      <AutoBackdrop variant="leads" />

      <section className="lv2-leads-hero">
        <div className="lv2-wrap lv2-center">
          <h1 className="lv2-h1">Un assistant IA <em>pour les dirigeants VO.</em></h1>
          <p className="lv2-lead lv2-leads-sub">
            VIQ.AI regroupe les 4 meilleurs moteurs IA au monde en un seul endroit et pour un seul abonnement. Analyse de vos performances sourcing, qualification et interprétation intelligente de vos mails et de votre agenda, pilotage proactif de vos objectifs, de vos prospects…
          </p>
          <p className="lv2-leads-hook">Centralisez vos flux d’information, structurez votre workflow et gardez les décisions prioritaires au même endroit.</p>
        </div>
      </section>

      <section className="lv2-leads-body">
        {/* §17-19 — Les mêmes slots que le formulaire pro : une seule
            configuration dans l'admin sert les deux surfaces. */}
        <AdFrame apiUrl={apiUrl} maxWidth={640}>
          <DemoLeadForm apiUrl={apiUrl} onPrivacy={onPrivacy} onDiscover={() => nav("/")} variant="leads_page" />
          <p className="lv2-leads-privacy">
            Vos coordonnées servent uniquement à vous recontacter au sujet de VehicleIQ.{" "}
            <button type="button" onClick={() => onPrivacy && onPrivacy("privacy")}>Confidentialité</button>
          </p>
        </AdFrame>
      </section>
    </main>
  );
}
